import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-rating-star',
  imports: [],
  templateUrl: './rid-rating-star.html',
})
export class RidRatingStar {
  filled = input<boolean>(false);
  label = input.required<string>();
}
